export enum DataImportPageMode {
  NEW_STORED_PRODUCT_IMPORT = 'new-stored-product-import',
  DATA_IMPORT = 'data-import',
}
